import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ButtonPrimitiveComponent} from '@tisa-group/client-ui/components/button-primitive';

@Component({
  selector: 'button[tisaButtonIcon]',
  templateUrl: './button-icon.component.html',
  styleUrls: ['button-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ButtonIconComponent extends ButtonPrimitiveComponent {
  readonly width = 'w-[60px]';
}
